module.exports = __webpack_public_path__ + "static/media/titleEditIcon.6c537b79.svg";